import { CompetenciaInput, DateInput, TextInput } from '@core/components/Inputs';
import RangeDateInput from '@core/components/Inputs/RangeDateInput';
import { SelectInput } from '@core/components/Select';
import { FormControlLabel, Grid, Switch } from '@material-ui/core';
import InputMonetario from 'app/components/Input/InputMonetario';
import SelectCategoria from 'app/components/Select/SelectCategoria';
import SelectConta from 'app/components/Select/SelectConta';
import SelectFornecedor from 'app/components/Select/SelectFornecedor';
import { useFormikContext } from 'formik';
import React from 'react';

const ContasPagarBuscaAvancadaForm = () => {
  const formikContext = useFormikContext();
  const { values, handleChange, handleBlur } = formikContext;

  const _errors = {};

  return (
    <Grid container style={{ padding: 16 }} spacing={3}>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <CompetenciaInput
          fullWidth
          onBlur={handleBlur}
          id="mesCompetencia"
          label="Mês competência"
          value={values?.mesCompetencia}
          onChange={handleChange}
          touched={!!_errors.mesCompetencia}
          error={_errors.mesCompetencia}
          helperText={_errors.mesCompetencia}
          format="MM/YYYY"
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <SelectInput
          id="situacao"
          label="Situação"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.situacao}
          error={_errors?.situacao}
          touched={!!_errors?.situacao}
          options={[
            { id: 'ABERTA', title: 'Aberta' },
            { id: 'BAIXADA', title: 'Baixada' },
            { id: 'PARCIAL', title: 'Parcial' },
            { id: 'EXCLUIDA', title: 'Excluída' },
            { id: 'TODAS', title: 'Todas' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectFornecedor
          handleChange={handleChange}
          handleBlur={handleBlur}
          fornecedor={values?.fornecedor}
          error={_errors.fornecedor}
          touched={!!_errors.fornecedor}
          autoFocus
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectCategoria
          id="categoria"
          label="Categoria"
          value={values?.categoria}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={100}
          natureza="DESPESA"
          touched={!!_errors.categoria}
          error={_errors.categoria}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <RangeDateInput
          id="dataVencimento"
          name="dataVencimento"
          value={[values.dataVencimentoInicio, values.dataVencimentoFim]}
          label="Período de vencimento"
          error={!!_errors.dataVencimento}
          helperText={_errors.dataVencimento}
          onBlur={handleBlur}
          onChange={(inicio, fim) => {
            formikContext.setFieldValue('dataVencimentoFim', fim);
            formikContext.setFieldValue('dataVencimentoInicio', inicio);
          }}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <RangeDateInput
          id="dataPagamento"
          name="dataPagamento"
          value={[values.dataPagamentoInicio, values.dataPagamentoFim]}
          label="Período de pagamento"
          error={!!_errors.dataPagamento}
          helperText={_errors.dataPagamento}
          onBlur={handleBlur}
          onChange={(inicio, fim) => {
            formikContext.setFieldValue('dataPagamentoFim', fim);
            formikContext.setFieldValue('dataPagamentoInicio', inicio);
          }}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <RangeDateInput
          id="dataLiquidacao"
          name="dataLiquidacao"
          value={[values.dataLiquidacaoInicio, values.dataLiquidacaoFim]}
          label="Período de liquidação"
          error={!!_errors.dataLiquidacao}
          helperText={_errors.dataLiquidacao}
          onBlur={handleBlur}
          onChange={(inicio, fim) => {
            formikContext.setFieldValue('dataLiquidacaoFim', fim);
            formikContext.setFieldValue('dataLiquidacaoInicio', inicio);
          }}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <DateInput
          fullWidth
          id="dataEmissao"
          label="Data de emissão"
          value={values?.dataEmissao}
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!_errors.dataEmissao}
          helperText={_errors.dataEmissao}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <InputMonetario
          fullWidth
          id="valor"
          label="Valor (R$)"
          handleBlur={handleBlur}
          value={values?.valor}
          touched={!!_errors.valor}
          error={_errors.valor}
          handleChange={handleChange}
          helperText={_errors.valor}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextInput
          id="documentoFiscal"
          label="Documento fiscal"
          fullWidth
          value={values?.documentoFiscal}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <SelectConta
          id="conta"
          name="conta"
          label="Conta"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.conta}
          touched={!!_errors?.conta}
          error={_errors?.conta}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <SelectInput
          id="formaPagamento"
          label="Forma de pagamento"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.formaPagamento}
          error={_errors?.formaPagamento}
          touched={!!_errors?.formaPagamento}
          options={[
            { id: 'CARTAO_CREDITO', title: 'Cartão de crédito' },
            { id: 'CARTAO_DEBITO', title: 'Cartão de débito' },
            { id: 'CHEQUE', title: 'Cheque' },
            { id: 'DEBITO_AUTOMATICO', title: 'Débito automático' },
            { id: 'DEBITO_CONTA', title: 'Débito em conta' },
            { id: 'DOC', title: 'DOC' },
            { id: 'TED', title: 'TED' },
            { id: 'TRANSFERENCIA_BANCARIA', title: 'Transferência. bancária' },
            { id: 'DINHEIRO', title: 'Dinheiro' },
            { id: 'OUTRAS', title: 'Outras' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <SelectInput
          id="origemLancamento"
          label="Origem de lançamento"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.origemLancamento}
          error={_errors?.origemLancamento}
          touched={!!_errors?.origemLancamento}
          options={[
            { id: 'COMPRA', title: 'Compras' },
            { id: 'CONTA_PAGAR', title: 'Contas a pagar' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControlLabel
          label="Buscar somente despesas regulares"
          control={
            <Switch
              id="despesasRegulares"
              name="despesasRegulares"
              value={values?.despesasRegulares}
              checked={values?.despesasRegulares}
              onChange={handleChange}
              onBlur={handleBlur}
              size="small"
              color="primary"
            />
          }
        />
      </Grid>
    </Grid>
  );
};

export default ContasPagarBuscaAvancadaForm;
